import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shared/shared-shadcn-ui';
import { type ComponentPropsWithoutRef, type FC } from 'react';

type Properties = {
  isOpen: boolean;
  onOpenChange: ComponentPropsWithoutRef<typeof Dialog>['onOpenChange'];
};

const FormSuccessDialog: FC<Properties> = ({ isOpen, onOpenChange }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="bg-ogn-blue pl-8 pr-8 py-6 lg:p-12 max-w-[940px] w-[calc(100%-40px)] !rounded-[16px] border-0">
        <DialogHeader>
          <DialogTitle className="text-[32px] font-bold text-ogn-bright-yellow font-roboto-condensed lg:text-[40px] text-center">
            Thank you!
          </DialogTitle>
          <DialogDescription className="text-ogn-white text-[min(6vw,22px)] lg:text-[28px] !mt-4 font-bold font-roboto-condensed  text-center pt-4">
            An Organogenesis representative <br className="block lg:hidden" />
            will be in touch with you soon.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export { FormSuccessDialog };
